import {useQuery} from "@tanstack/react-query";
import {readBeforeOrderListEx} from "../../../../../api/product/ProductExApi";
import {ProductExDetailBeforeOrderListSearchParamType} from "../interface";

type Props = {
    param: ProductExDetailBeforeOrderListSearchParamType;
};

export const useReadBeforeOrderListEx = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readBeforeOrderListEx", param],
        queryFn: async () => await readBeforeOrderListEx(param),
        select: (res) => res?.data.result ?? null,
        enabled: param.userId !== 0
    });

    return {data};
};
